module.exports = __webpack_public_path__ + "assets/f325b25e330575658ea184db0eb66ba9.jpg";